// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../node_modules/@vue/cli-service/node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/@vue/cli-service/node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.target-groups[data-v-6196a4a9]{display:grid;grid-template-columns:repeat(auto-fit,minmax(200px,1fr));grid-gap:var(--gap-md);width:100%;height:-moz-max-content;height:max-content;overflow:hidden}`, ""]);
// Exports
export default ___CSS_LOADER_EXPORT___;
